import { IncidentDetail } from '@hakimo-ui/hakimo/types';
import { FIELD_LABEL_CLASS, Panel } from '../Panel';
import { formatDate, formatTime } from '../util';

interface Props {
  incident: IncidentDetail;
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className={FIELD_LABEL_CLASS}>{label}</div>
      <div className="text-onlight-text-1 dark:text-ondark-text-1 mt-0.5 text-sm font-semibold">
        {value}
      </div>
    </div>
  );
}

function TimeRow({
  label,
  isoUtc,
  zone,
}: {
  label: string;
  isoUtc: string | null;
  zone: string | null;
}) {
  return (
    <div className="flex items-baseline gap-3 text-sm">
      <span className={`${FIELD_LABEL_CLASS} w-10 shrink-0`}>{label}</span>
      <span className="text-onlight-text-1 dark:text-ondark-text-1 font-semibold">
        {formatDate(isoUtc, zone)}
      </span>
      <span className="text-onlight-text-1 dark:text-ondark-text-1 font-semibold">
        {formatTime(isoUtc, zone)}
      </span>
    </div>
  );
}

export function IncidentSummaryPanel({ incident }: Props) {
  return (
    <Panel className="space-y-4">
      <Field label="Location" value={incident.location_name || '-'} />

      <div>
        <div className={FIELD_LABEL_CLASS}>Date and Time</div>
        <div className="mt-1">
          <TimeRow
            label="Start"
            isoUtc={incident.incident_start_time_utc}
            zone={incident.timezone}
          />
          <TimeRow
            label="End"
            isoUtc={incident.incident_end_time_utc}
            zone={incident.timezone}
          />
        </div>
      </div>

      <Field
        label="Incident Category"
        value={incident.incident_category || '-'}
      />
      <Field
        label="Resolution Reason"
        value={incident.resolution_reason || '-'}
      />
      <Field label="Escalated By" value={incident.escalated_by || '-'} />
      <Field label="Resolved By" value={incident.resolved_by || '-'} />
    </Panel>
  );
}

export default IncidentSummaryPanel;
